import { cn } from "@/lib/cn";
import type { ReactNode } from "react";
import { useActive } from "../providers";
import type { TabTitleType, TabsPayload } from "../types";
import { Title } from "./Title";

export const Wrapper = ({
  id,
  isMobile = false,
  title,
  settings,
  children,
}: {
  id: string;
  children: ReactNode;
  isMobile?: boolean;
  title?: TabTitleType;
  settings?: TabsPayload;
}) => {
  const { active } = useActive();
  return (
    <div
      className={cn("set-wrapper tw-w-full", {
        "swiper-slide": isMobile,
        "tw-hidden": active !== id && !isMobile,
      })}
    >
      {isMobile && title && settings && (
        <div className="tw-flex tw-justify-start">
          <Title
            settings={settings}
            title={title}
            attributes={{}}
            forceActive
            className="tw-mb-4 tw-inline-flex tw-h-auto tw-w-auto tw-self-start"
          />
        </div>
      )}
      {children}
    </div>
  );
};
